export const isHtmlEmpty = (html?: string): boolean => {
  if (!html) return true
  // Try DOMParser on the client for the most robust text extraction
  try {
    if (typeof window !== 'undefined' && 'DOMParser' in window) {
      const doc = new DOMParser().parseFromString(html, 'text/html')
      const text = (doc.body.textContent || '').replace(/\u00a0/g, ' ').trim()
      return text.length === 0
    }
  } catch {
    // fall back to regex below
  }
  // SSR / fallback: strip tags, scripts/styles, &nbsp;
  const text = html
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;|&#160;/gi, ' ')
    .trim()
  return text.length === 0
}
